import config from '../config';

import {LANGUAGES} from '../constants/dia';

let messages = {};
LANGUAGES.forEach(lang => {
  messages[lang] = require('../../src/i18n/' + lang + '.js').default;
});

function initialState(lang) {
  let defaultLocale = config.defaultLanguage || LANGUAGES[0];
  lang = lang || defaultLocale;
  lang = LANGUAGES.indexOf(lang) >= 0 ? lang : defaultLocale;

  return {
    intl: {
      defaultLocale,
      locale: lang,
      messages: messages[lang].messages
    },
  };
}

export default initialState;



/** WEBPACK FOOTER **
 ** ./src/store/initialState.js
 **/